import { Injectable, InjectionToken } from "@angular/core";
import { ContactRequestSendCommand, ContactRequestSendCommandResult } from "../../INTEGRA_Shop_Client";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export abstract class IContactRequestApiService {
  abstract contactRequestSend(command: ContactRequestSendCommand): Observable<ContactRequestSendCommandResult>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IContactRequestApiServiceToken = new InjectionToken<IContactRequestApiService>('IContactRequestApiServiceToken');
